export const getBottomState = (index: number, totalRows: number) => {
	if (index === 4 && totalRows === 4) {
		return true;
	}
	return totalRows > 4 && (index === totalRows - 1 || index === totalRows);
};
